import Questionnair from './Questionnair';
import Editor from './QuestionnairEditor';
import Answer from './QuestionnairAnswer';
import '../assets/iconfonts/iconfont.css';

Questionnair.Editor = Editor;
Questionnair.Answer = Answer;

export default Questionnair;